<!-- Evaluation.vue -->
<template>
	<div class="ui-evaluation">
		<div class="ui-evaluation-header">
			<div class="flex-header">
				<div
					v-for="(item, index) in staticData"
					v-bind:key="item.id"
					v-bind:class="{ active: currentTag == item.value }"
					v-on:click="changeTab(item.value, item.grade)"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
		<div
			class="ui-evaluation-body"
			v-infinite-scroll="loadMore"
			infinite-scroll-disabled="loading"
			infinite-scroll-distance="10"
		>
			<div
				class="list"
				v-for="(item, index) in reviewList"
				v-if="reviewList.length > 0"
			>
				<div class="item">
					<span>
						<img class="avatar" :src="item.member_avatar" />
						{{ item.geval_isanonymous?'匿名':item.geval_frommembername }}
						<span
							v-bind:class="{
								'good-review': item.geval_scores > 3,
								'medium-review': item.geval_scores > 1,
								'bad-review': item.geval_scores == 1
							}"
							>{{ getGrade(item.geval_scores) }}</span
						>
					</span>

					<span>{{ getTime(item.geval_addtime) }}</span>
				</div>
				<p v-if="item.geval_content">{{ item.geval_content }}</p>
				<p v-if="!item.geval_content">无评价信息</p>
        <p class="explain" v-if="item.geval_explain">掌柜回复：{{ item.geval_explain }}</p>
				<div class="geval-image-list" v-if="item.geval_image && item.geval_image.length">
					<div class="geval-image-item" v-for="(image,i) in item.geval_image" :key="i">
						<div class="image-wrapper"><img class="image" :src="image" @click="openImage(image)" /></div>
					</div>
				</div>
			</div>

			<div class="list-empty" v-if="reviewList.length <= 0">
        <div class="iconfont empty-icon">&#xe636;</div>
				<p>本商品暂无评价</p>
			</div>
		</div>
		<mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
			<img :src="showimage" :style="getBannerStyle" @click="isshow=false">
		</mt-popup>
	</div>
</template>

<script>
import { evaluation } from '../static'
import { getReviewList } from '../../../../api/homegoodsdetail'
export default {
  data () {
    return {
		showimage: '',
		isshow: false,
      staticData: evaluation,
      id: this.$store.state.goodsdetail.currentProductId
        ? this.$store.state.goodsdetail.currentProductId
        : '',
      currentTag: 'total',
      grade: 0,
      subTotal: {},
      reviewList: [],
      page: 0,
      loading: false,
      hasmore: true
    }
  },
  created () {
  },
	computed: {
		getBannerStyle: function () {
			const { width, height } = window.screen
			let itemWidth = width
			let itemHeight = height
			return {
				maxWidth: itemWidth + 'px',
				maxHeight: itemHeight + 'px'
			}
		}
	},
  methods: {
	  openImage (src) {
		  this.showimage = src
		  this.isshow = true
	  },
    loadMore () {
      if(this.loading){
        return
      }
      
      this.loading = true
      if (this.hasmore) {
        this.page = ++this.page
        this.getReviewList(true)
      }
    },
    getReviewList (ispush) {
      getReviewList(this.id, this.grade, 10, this.page).then(res => {
        this.loading = false
        if (res) {
          if (ispush) {
            this.reviewList = this.reviewList.concat(res.result.goods_eval_list)
          } else {
            this.reviewList = res.result.goods_eval_list
          }
          this.hasmore = res.result.hasmore
        }
      })
    },
    changeTab (value, grade) {
      this.currentTag = value
      this.grade = grade
      this.getReviewList(false)
    },
    getGrade (grade) {
      if (grade == 1) {
        return '差评'
      } else if (grade > 3) {
        return '好评'
      } else {
        return '中评'
      }
    },
    getTime (timestamps) {
      let date = new Date(timestamps * 1000)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-evaluation {
	.ui-evaluation-header {
		background: #ffffff;
		.flex-header {
			width: auto;
			display: flex;
			display: -webkit-flex;
			display: -moz-flex;
			flex-basis: 100%;
			justify-content: space-around;
			align-content: center;
			align-items: center;
			height:2.2rem;
			div {
				color: $descTextColor;
				font-size:$subFontSize;
				height:1.2rem;
				border: 0.5px solid #eee;
				padding: 0 0.45rem;
				line-height: 1.2rem;
				text-align: center;
				border-radius: 1.2rem;
				&.active {
					color: $primaryColor;
					border: 0.5px solid $primaryColor;
				}
			}
		}
	}
	.ui-evaluation-body {
		padding: 0 0.75rem;
		background: rgba(255, 255, 255, 1);
		.list {
			padding: 0.75rem 0;
			border-bottom: 0.5px dashed #eee;
			color: #333;
			font-size:$subFontSize;
			.item {
				overflow: hidden;
				padding-bottom:0.75rem;
				display: flex;
				justify-content: space-between;
				align-content: center;
				align-items: center;
				.avatar{width:2rem;height: 2rem;border-radius: 50%;margin-right: .3rem;}
				span {
					&:first-child {
						display: flex;
						justify-content: space-around;
						align-content: center;
						align-items: center;
						span {
							margin-left:0.75rem;
							color: #ffffff;
							font-size:$fontSize;
						}
					}
					&:last-child {
						color: #999999;
						font-size:$fontSize;
					}
					&.good-review {
						background: #fc2e39;
						width:1.8rem;
						height:0.8rem;
						text-align: center;
						background-size: cover;
						line-height:0.8rem;
						border-radius:0.4rem;
					}
					&.medium-review {
						background: $primaryColor;
						width:1.8rem;
						height:0.8rem;
						text-align: center;
						background-size: cover;
						line-height:0.8rem;
						border-radius:0.4rem;
					}
					&.bad-review {
						background: #c3c3c3;
						width:1.8rem;
						height:0.8rem;
						text-align: center;
						background-size: cover;
						line-height:0.8rem;
						border-radius:0.4rem;
					}
				}
			}
			p {
				padding: 0;
				margin: 0;
				flex-basis: 100%;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
      .explain{color:orange}
		}
		.list-empty {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
      .empty-icon{font-size:3rem;padding:1rem 0;color:#999}
			img {
				width:2.75rem;
			}
			p {
				color: #7c7f88;
				font-size:$subFontSize;
				padding: 0;
				margin: 0;
				font-weight: normal;
			}
		}
	}
	.geval-image-list{overflow: hidden;margin-top:1rem;
		.geval-image-item{width:33.33%;height:0;padding-bottom: 33.33%;float: left;position: relative;
			.image-wrapper{position: absolute;left:0;right:0.1rem;top:0;bottom:0.1rem;
				.image{width:100%;height: 100%;}
			}
		}
	}
}
</style>
